<script lang="ts">
import { TypographyTags } from '@/utils/accessibility';
import { BuilderComponent } from '@/utils/cms';
import { fonts } from '@/utils/typography';

export const Header6Registration: BuilderComponent = {
  name: 'Header6',
  canHaveChildren: true,
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Header 6 text here' } },
    },
  ],
  defaultStyles: {
    marginTop: '0px',
  },
};
</script>

<script setup lang="ts">
withDefaults(
  defineProps<{
    font?: 'sofia-pro' | 'gelica';
    headerTag?: TypographyTags;
  }>(),
  {
    font: 'sofia-pro',
    headerTag: 'h6',
  },
);
</script>

<template>
  <component
    :is="headerTag"
    class="text-sm font-semibold leading-4 header-6 lg:text-base lg:leading-5"
    :class="fonts[font]"
  >
    <slot />
  </component>
</template>

<style scoped>
.header-6 {
  @apply mb-0;
}
</style>
